import { render, staticRenderFns } from "./admin-tcr-events.vue?vue&type=template&id=ad44d22a&scoped=true&"
import script from "./admin-tcr-events.vue?vue&type=script&lang=js&"
export * from "./admin-tcr-events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad44d22a",
  null
  
)

export default component.exports